// import React from "react";
// import styles from "./dataTable.module.css";

// const CustomPagination = ({ currentPage, rowsPerPage, totalCount, onPageChange }) => {
//   const totalPages = Math.ceil(totalCount / rowsPerPage);

//   if (totalPages <= 1) return null;

//   const handleClick = (page) => {
//     if (page >= 1 && page <= totalPages && page !== currentPage) {
//       onPageChange(page);
//     }
//   };

//   return (
//     <div className={styles.paginationContainer}>
//       <button onClick={() => handleClick(currentPage - 1)} disabled={currentPage === 1}>
//         Prev
//       </button>

//       {[...Array(totalPages)].map((_, index) => {
//         const page = index + 1;
//         return (
//           <button
//             key={page}
//             onClick={() => handleClick(page)}
//             className={currentPage === page ? styles.active : ""}
//           >
//             {page}
//           </button>
//         );
//       })}

//       <button onClick={() => handleClick(currentPage + 1)} disabled={currentPage === totalPages}>
//         Next
//       </button>
//     </div>
//   );
// };

// export default CustomPagination;

import React from "react";
import styles from "./dataTable.module.css";

const CustomPagination = ({ currentPage, rowsPerPage, totalCount, onPageChange }) => {
  const totalPages = Math.ceil(totalCount / rowsPerPage);

  if (totalPages <= 1) return null;

  const handleClick = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
  };

  // Function to generate page numbers
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 11; // Maximum number of page buttons to show
    const halfMaxPages = Math.floor(maxPagesToShow / 2);

    if (totalPages <= maxPagesToShow) {
      // If total pages are less than or equal to max pages, show all
      return [...Array(totalPages)].map((_, index) => index + 1);
    }

    // Determine start and end pages
    let startPage = Math.max(1, currentPage - halfMaxPages);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust if we're near the beginning or end
    if (currentPage <= halfMaxPages) {
      startPage = 1;
      endPage = maxPagesToShow;
    } else if (currentPage > totalPages - halfMaxPages) {
      endPage = totalPages;
      startPage = totalPages - maxPagesToShow + 1;
    }

    // Generate page numbers
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className={styles.paginationContainer}>
      {/* Previous button */}
      <button onClick={() => handleClick(currentPage - 1)} disabled={currentPage === 1}>
        Prev
      </button>

      {/* First page button if not already shown */}
      {pageNumbers[0] > 1 && (
        <>
          <button onClick={() => handleClick(1)}>{1}</button>
          {pageNumbers[0] > 2 && <span>...</span>}
        </>
      )}

      {/* Page number buttons */}
      {pageNumbers.map((page) => (
        <button
          key={page}
          onClick={() => handleClick(page)}
          className={currentPage === page ? styles.active : ""}
        >
          {page}
        </button>
      ))}

      {/* Last page button if not already shown */}
      {pageNumbers[pageNumbers.length - 1] < totalPages && (
        <>
          {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && <span>...</span>}
          <button onClick={() => handleClick(totalPages)}>{totalPages}</button>
        </>
      )}

      {/* Next button */}
      <button onClick={() => handleClick(currentPage + 1)} disabled={currentPage === totalPages}>
        Next
      </button>
    </div>
  );
};

export default CustomPagination;